import { URL_TYPES } from '@wix/wix-vod-constants/common';
import { InternalError, SortOrders, } from '@wix/wix-vod-constants/api-types';
import { toError } from '../../parsers/to-error';
import { parseYoutubeVideo } from './parsers/video';
import { parseVideoItem } from '../../parsers/video-item';
import { YoutubeChannelsService } from './youtube-channels-service';
import { YoutubeService } from './pixwix/youtube';
export class YoutubeVideosService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.youtubeService = new YoutubeService(httpClient);
        this.youtubeChannelsService = new YoutubeChannelsService(httpClient);
    }
    mapParams(channel, options) {
        var _a;
        const { externalId, urlType } = channel;
        const item = {
            externalId,
            urlType,
            pageToken: options.paging.cursor,
            itemsCount: (_a = options.paging.size) !== null && _a !== void 0 ? _a : 0,
        };
        return item;
    }
    getCategoryIdToTitleMapping(categoryItems = []) {
        return _.reduce(categoryItems, (categoriesByIds, category) => ({
            [category.id]: category.snippet.title,
        }), {});
    }
    addCategory(categoriesByIds, item) {
        const categoryId = _.get(item, 'snippet.categoryId');
        const category = categoriesByIds[categoryId];
        if (category) {
            _.set(item, 'snippet.category', category);
        }
        return item;
    }
    mapToVodPaginatedResponse(response, options) {
        const { nextPageToken, playlistItems, videoItems, categoryItems, channelItems, } = response.data;
        const categoriesByIds = this.getCategoryIdToTitleMapping(categoryItems);
        const channelsData = _.keyBy(channelItems, 'id');
        const addCategoryToVideo = (item) => this.addCategory(categoriesByIds, item);
        const mergedItems = videoItems.map((videoItem, index) => _.merge(videoItem, playlistItems[index]));
        return {
            status: response.status,
            sort: options.sort,
            paging: Object.assign(Object.assign({}, options.paging), { cursor: nextPageToken }),
            data: _(mergedItems)
                .map(addCategoryToVideo)
                .map((item) => {
                var _a, _b;
                return (Object.assign(Object.assign({}, parseYoutubeVideo(item)), { publisher: (_b = (_a = channelsData[item.snippet.channelId]) === null || _a === void 0 ? void 0 : _a.snippet) === null || _b === void 0 ? void 0 : _b.title }));
            })
                .value(),
        };
    }
    async listYoutubeChannelVideosInternal(channel, options) {
        const params = this.mapParams(channel, options);
        const response = await this.youtubeService.getChannelVideos(params);
        return this.mapToVodPaginatedResponse(response, options);
    }
    async getVideosByChannelId(channelId, options) {
        return this.listYoutubeChannelVideosInternal({ externalId: channelId, urlType: URL_TYPES.CHANNEL }, options).catch(toError);
    }
    async getVideosByPlaylistId(playlistId, options) {
        return this.listYoutubeChannelVideosInternal({ externalId: playlistId, urlType: URL_TYPES.PLAYLIST }, options).catch(toError);
    }
    async getVideosByUserName(userName, options) {
        return this.youtubeService
            .getChannelsByUsername(userName)
            .then((response) => response.data.items[0])
            .then((channel) => channel.id)
            .then((channelId) => this.getVideosByChannelId(channelId, options))
            .catch(toError);
    }
    async getYoutubeVideoByIdWithChannelData(videoId) {
        const videoResponse = await this.getYoutubeVideoById(videoId);
        const channel = await this.youtubeChannelsService
            .getChannelsByIds([videoResponse.data.channelId])
            .then((response) => response.data[0]);
        return Object.assign(Object.assign({}, videoResponse), { data: Object.assign(Object.assign({}, videoResponse.data), { publisher: channel ? channel.title : null }) });
    }
    async getVideosByUrl(url, skipVideos) {
        let type;
        let id;
        try {
            const result = skipVideos
                ? this.youtubeService.parseChannelUrl(url)
                : this.youtubeService.parseVideoUrl(url);
            type = result.type;
            id = result.id;
        }
        catch (e) {
            return Promise.reject(new InternalError(0, 'wpm_error.malformed_external_link'));
        }
        const options = {
            paging: {
                cursor: null,
                size: 50,
            },
            sort: {
                order: SortOrders.Relevance,
            },
        };
        switch (type) {
            case URL_TYPES.CHANNEL:
                return this.getVideosByChannelId(id, options);
            case URL_TYPES.PLAYLIST:
                return this.getVideosByPlaylistId(id, options);
            case URL_TYPES.USER_NAME:
                return this.getVideosByUserName(id, options);
            default:
                try {
                    const response = await this.getYoutubeVideoByIdWithChannelData(id);
                    return Object.assign(Object.assign({}, response), { data: [response.data] });
                }
                catch (error) {
                    return toError(error);
                }
            // .catch(toError);
        }
    }
    async getYoutubeVideoById(videoId) {
        const response = await this.youtubeService.getVideoById(videoId);
        const { items, categoryItems } = response.data;
        const categoriesByIds = this.getCategoryIdToTitleMapping(categoryItems);
        const item = this.addCategory(categoriesByIds, items[0]);
        const parsedItem = parseYoutubeVideo(item);
        return Object.assign(Object.assign({}, response), { data: Object.assign(Object.assign({}, parsedItem), { id: parsedItem.externalId }) });
    }
    async listYoutubeChannelVideos(channel, options) {
        const response = await this.listYoutubeChannelVideosInternal(channel, options);
        return Object.assign(Object.assign({}, response), { data: response.data.map(parseVideoItem) });
    }
}
//# sourceMappingURL=youtube-videos-service.js.map